export const document = (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none"
    className="transition-colors duration-200 hover:fill-[#012169] group"
  >
    <path 
      className="group-hover:stroke-[#012169] group-hover:fill-[#012169]"
      d="M12.0797 4.31823L12.1733 4.49661H12.3748H21.0373C22.1353 4.49661 23.029 5.3669 23.029 6.45078V20.2883C23.029 21.3792 22.1657 22.2425 21.0748 22.2425H2.96231C1.8714 22.2425 1.00814 21.3792 1.00814 20.2883V3.71328C1.00814 2.62238 1.8714 1.75911 2.96231 1.75911H9.56231C10.291 1.75911 10.9339 2.16907 11.2937 2.8212L12.0797 4.31823ZM21.0748 21.2216C21.5964 21.2216 22.0081 20.8099 22.0081 20.2883V6.45078C22.0081 5.92919 21.5964 5.51745 21.0748 5.51745H11.8873C11.718 5.51745 11.525 5.40449 11.4286 5.23859L10.383 3.29681C10.2158 2.96652 9.91686 2.77995 9.56231 2.77995H2.96231C2.44071 2.77995 2.02897 3.19169 2.02897 3.71328V20.2883C2.02897 20.8099 2.44071 21.2216 2.96231 21.2216H21.0748Z" 
      fill="#9CA3AF" 
      stroke="#9CA3AF" 
      strokeWidth="0.666667"
    />
    <path 
      className="group-hover:fill-[#012169]"
      d="M14.6997 13.4252L12.8622 15.2252V9.7502C12.8622 9.3002 12.4872 8.8877 11.9997 8.8877C11.5122 8.8877 11.1372 9.2627 11.1372 9.7502V15.2627L9.26221 13.4252C8.92471 13.0877 8.39971 13.0877 8.06221 13.4252C7.72471 13.7627 7.72471 14.2877 8.06221 14.6252L11.3622 17.8502C11.5122 18.0002 11.7372 18.0752 11.9622 18.0752C12.1872 18.0752 12.3747 18.0002 12.5622 17.8502L15.8622 14.6252C16.1997 14.2877 16.1997 13.7627 15.8622 13.4252C15.5622 13.0877 15.0372 13.0877 14.6997 13.4252Z" 
      fill="#9CA3AF"
    />
  </svg>
);